// import Swiper JS
import Swiper from "swiper";
import { Autoplay } from "swiper/modules";

Swiper.use([Autoplay]);

const swiper = new Swiper(".sponsor", {
  // Optional parameters
  loop: true,
  slidesPerView: 5,
  modules: [Autoplay],
  breakpoints: {
    320: {
      slidesPerView: 2,
    },
    480: {
      slidesPerView: 2,
    },
    640: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 4,
    },
    992: {
      slidesPerView: 5, 
    },
  },
  autoplay: {
    delay: 1,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  },
  freeMode: true,
  speed: 5000,
});
